import React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import { getStorageUser } from "../helpers/api_helper";

const Footer = () => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Sistema de Monitoreo</Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
